import moment from 'moment/min/moment-with-locales';

module.exports = {

   formatDate(date, format) {
      moment.locale('sv');
      return moment(date).format(format);
   },

   getDate() {
      moment.locale('sv');
      return moment();
   },
   
   dateDiffFromTodayinDays(date) {
    moment.locale('sv');
    var now = moment();
    var theDate = moment(date);  
    var diffTime = theDate.diff(now,'days');
    return diffTime;    
    }
};